import QueueItem from './QueueItem';
import AJAXLoader from './AJAXLoader';
import {WEBAUDIO_SUPPORT, MP3_SUPPORT} from '../../layout/features';

let EXT = new Map();
EXT.set('mp3', 'audio/mpeg');
EXT.set('ogg', 'audio/ogg');

let extensionCheck = new RegExp(`\\.(${Array.from(EXT.keys()).join('|')})$`); // XXX: magic!

let LEGACY_MODE = !WEBAUDIO_SUPPORT;

/**
 * Order by support and return ordered array
 * @param {String|Array} src
 * @return {Array}
 * @private
 */
function orderSource(src) {
    if (src instanceof Array) {
        // Select best matching format. This can become more complex in future
        src.sort(function (a, b) {
            // float supported extension to top
            [, a] = (extensionCheck.exec(a) || []);
            [, b] = (extensionCheck.exec(b) || []);

            if(a && b) {
                if(MP3_SUPPORT) {
                    return a.toLowerCase() == 'mp3' ? -1 : 1;
                }
                else {
                    return a.toLowerCase() == 'mp3' ? 1 : -1;
                }
            }
            return 0;
        });
        return src;
    }
    return src ? [src] : [];
}

/**
 * @class
 * @inheritDoc
 * @extends module:media.module:loaders.QueueItem
 * @memberof module:media.module:loaders
 * @classdesc Загрузчик звука
 */
class SoundLoader extends QueueItem {

    constructor(src, context = null) {
        super(src);
        this.context = context;
    }

    destructor() {
        super.destructor();
        this.context = null;
    }

    prepareData(src) {
        this._sources = orderSource(src);
        if (LEGACY_MODE) {
            let item = document.createElement('audio');
            item.autoplay = false;
            item.controls = false;
            item.preload = "auto";
            item.src = this._sources[0];

            for (let url of this._sources) { // let browser select better source
                let s = item.appendChild(document.createElement('source'));
                s.src = url;
            }
            return item;
        }
    }

    prepareKey(src) {
        return orderSource(src);
    }

    cached() {
        // get by any of alternate URLs
        let item = null;
        for (let src of this._sources) {
            item = super.cached(src);
            if (item) {
                return item;
            }
        }
    }

    cache() {
        // cache each of alternate URLs
        let item = this.data;
        for (let src of this._sources) {
            super.cache(src);
        }
    }

    _legacyLoad(cache) {
        let self = this, fn = (e) => {
            if (!self.complete) {
                self.data.removeEventListener('canplay', fn);
                self.data.removeEventListener('canplaythrough', fn);
                self.data.removeEventListener('error', fn);
                self.data.removeEventListener('stalled', fn);
                if (e.type == 'error' || e.type == 'stalled') {
                    self._status = 'error';
                    self._statusMessage = 'Error loading audio';
                }
                self.completeLoad(cache);
            }
        };

        this.data.addEventListener('canplay', fn);
        this.data.addEventListener('canplaythrough', fn);
        this.data.addEventListener('error', fn);
        this.data.addEventListener('stalled', fn);
        this.data.load();
    }

    load(cache = true) {
        super.load(cache);
        if (!this.complete) {
            if (LEGACY_MODE) return this._legacyLoad(cache);

            if (this._sources.length) {
                let src = this._sources.shift();
                let self = this, loader = new AJAXLoader(src, 'arraybuffer');
                loader.once('success', (e) => {
                    if (!e.target.data) {
                        return self.load(cache);
                    }

                    self.context.decodeAudioData(e.target.data,
                        (buffer) => {
                            self.data = buffer;
                            self.key = e.target.key;
                            self._sources = [e.target.key];
                            self._statusMessage = 'OK';
                            self.completeLoad(cache);
                        },

                        // error decoding
                        () => {
                            self._statusMessage = self._statusMessage || '';
                            self._statusMessage += `Error decoding ${src}\n`;
                            self.load(cache);
                        }
                    );

                });
                loader.once('error', (e) => {
                    self._statusMessage = self._statusMessage || '';
                    self._statusMessage += `${e.message}\n`;
                });
                loader.load(cache);
            }
            else {
                // not completed, no more sources
                this._status = 'error';
                this._statusMessage = 'All provided sources are invalid!';
                this.completeLoad(cache);
            }
        }
    }
}

export default SoundLoader;